import React from 'react';

export interface ScrollableDropdownContentProps {
    leftHeaderContent?: React.ReactNode;
    headerPrompt?: React.ReactNode;
    rightHeaderContent?: React.ReactNode;
    leftFooterContent?: React.ReactNode;
    rightFooterContent?: React.ReactNode;
    children?: React.ReactNode;
}

export class ScrollableDropdownContent extends React.Component<ScrollableDropdownContentProps> {
    render() {
        const {
            leftHeaderContent,
            rightHeaderContent,
            headerPrompt,
            leftFooterContent,
            rightFooterContent,
            children,
        } = this.props;

        return (
            <div className="scrollable-dropdown">
                {(leftHeaderContent || rightHeaderContent || headerPrompt) && (
                    <div className="scrollable-dropdown__header">
                        {leftHeaderContent && (
                            <div className="scrollable-dropdown__header__left-content">
                                {leftHeaderContent}
                            </div>
                        )}
                        {rightHeaderContent && (
                            <div className="scrollable-dropdown__header__right-content">
                                {rightHeaderContent}
                            </div>
                        )}
                        {headerPrompt && (
                            <div className="scrollable-dropdown__header-prompt">{headerPrompt}</div>
                        )}
                    </div>
                )}
                <div className="scrollable-dropdown__content-scroll">
                    <div className="scrollable-dropdown__content-scroll__inner">{children}</div>
                </div>
                {(leftFooterContent || rightFooterContent) && (
                    <div className="scrollable-dropdown__footer">
                        {leftFooterContent && (
                            <div className="scrollable-dropdown__footer__left-content">
                                {leftFooterContent}
                            </div>
                        )}
                        {rightFooterContent && (
                            <div className="scrollable-dropdown__footer__right-content">
                                {rightFooterContent}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
export default ScrollableDropdownContent;
